// Fields to General Information
export default [
    {
        // General fields[0] - Nombre
        field: 'name',
        type: 'text',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: ['required'],
    },
    {
        // General fields[1] - Alias
        field: 'alias_name',
        type: 'text',
        vuetifyProps: {
            label: 'Alias',
        },
        rules: [],
    },
    {
        // General fields[2] - Descripción
        field: 'description',
        type: 'text',
        vuetifyProps: {
            label: 'Descripción',
        },
        rules: ['required'],
    },
    {
        // General fields[3] - Familia
        field: 'wh_family_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Familia',
        },
        options: {
            data: [],
            text: 'family',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        // General fields[4] - Subfamilia
        field: 'wh_subfamily_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Subfamilia',
            'no-data-text': '¡ Subfamilias No encontradas!',
        },
        options: {
            data: [],
            text: 'subfamily',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        // General fields[5] - Generar ingreso de varios UPC
        field: 'upc_codes',
        type: 'combobox',
        vuetifyProps: {
            label: 'UPC',
        },
        rules: ['required'],
    },
    // General fields[6] - Generar UPC y Código Interno (como DiCal)
    {
        // General fields[7] - Código Interno
        field: 'internal_code',
        type: 'text',
        vuetifyProps: {
            label: 'Código interno',
        },
        rules: ['required'],
    },
    {
        // General fields[8] - Etiquetas
        field: 'tags',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Etiquetas',
            multiple: true,
            chips: true,
            'deletable-chips': true,
        },
        options: {
            data: [],
            text: 'tag',
            value: 'id',
        },
    },
]
